import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import "./MiniCalendar.css";

interface CalendarEvent {
  title: string;
  date: string;
  eventType: string;
}

interface MiniCalendarProps {
  onDateClick: (date: string) => void;
  events: CalendarEvent[];
  selectedDate: string | null;
}

const MiniCalendar: React.FC<MiniCalendarProps> = ({ onDateClick, events, selectedDate }) => {
  const handleDateClick = (info: DateClickArg) => {
    onDateClick(info.dateStr);
  };

  // Raggruppa gli eventi per data e conserva solo il primo evento di ogni giorno
  const filteredEvents = Object.values(
    events.reduce((acc, event) => {
      if (!acc[event.date]) {
        acc[event.date] = event; // Aggiungi solo il primo evento per ogni data
      }
      return acc;
    }, {} as Record<string, CalendarEvent>)
  );

  return (
    <div className="mini-calendar-container custom-mini-calendar">
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          left: "title",
          center: "",
          right: "prev,next",
        }}
        locale="it"
        buttonText={{
          today: "Oggi",
        }}
        height="auto"
        dayMaxEvents={true}
        events={filteredEvents} // Usa gli eventi filtrati
        fixedWeekCount={false}
        showNonCurrentDates={true}
        dayCellClassNames={(arg) => (selectedDate === arg.dateStr ? ["fc-day-selected"] : [])}
        eventContent={(eventInfo) => <div className={`event-dot ${eventInfo.event.extendedProps.eventType}`}></div>}
        dateClick={handleDateClick}
        firstDay={1}
      />
    </div>
  );
};

export default MiniCalendar;
